export { data, style };
const data ={
		title: "Hiring Form",
		url: "https://docs.google.com/forms/d/e/1FAIpQLScv14YO_AbYd7P8d3d0K-MQhDB2SbwnnORTFacmBAzbhOEzSA/viewform"
	},
	style = {
	
	}